import React from "react";
import './Footer.css'
import logo from '../static/Logo.svg'

const Footer = () => {
    const handleLinkClick = (sectionId) => {
        const element = document.getElementById(sectionId);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        // Newsletter signup logic would go here
        alert('Thank you for subscribing to our newsletter!');
    };

    return(
        <>
            <div className="footer" id="contact"> 
                <div className="company-info">
                    <img className="flogo" src={logo} alt="Appmend Logo"/>
                    <p className="company-description">
                        Transforming technology education and innovation through comprehensive training, development, and consultation services.
                    </p>
                    <p className="copyright">© 2024 Appmend. All rights reserved</p>
                    <div className="sociallinks">
                        <i className="fa-brands fa-linkedin" title="LinkedIn"></i>
                        <i className="fa-brands fa-twitter" title="Twitter"></i>
                        <i className="fa-brands fa-github" title="GitHub"></i>
                        <i className="fa-solid fa-envelope" title="Email"></i>
                    </div>
                </div>
                <div className="links">
                    <div className="main-col">
                        <div className="col1">
                            <p className="list-heading">Company</p>
                            <ul>
                                <li onClick={() => handleLinkClick('about')}>About Us</li>
                                <li onClick={() => handleLinkClick('services')}>Services</li>
                                <li onClick={() => handleLinkClick('products')}>Products</li>
                                <li>Careers</li>
                                <li>Contact Us</li>
                            </ul>
                        </div> 
                        <div className="col2">
                            <p className="list-heading">Services</p>
                            <ul>
                                <li>Training Programs</li>
                                <li>Web Development</li>
                                <li>DevOps Consultation</li>
                                <li>Cloud Solutions</li>
                                <li>AI Development</li>
                            </ul>
                        </div>
                        <div className="col4">
                            <p className="list-heading">Products</p>
                            <ul>
                                <li>Homoeomend</li>
                                <li onClick={() => window.open('https://dhanfree.com', '_blank')}>Dhanfree</li>
                            </ul>
                        </div>
                    </div>
                    
                    <div className="col3">
                        <p className="list-heading">Get In Touch</p>
                        <div className="contact-info">
                            <p>📧 info@appmend.in</p>
                            <p>🌐 appmend.in</p>
                        </div>
                        <p className="newsletter-title">Newsletter</p>
                        <form onSubmit={handleSubmit}>
                            <input placeholder="Your email address" type="email" required/>
                            <button type="submit"><i className="fa-solid fa-paper-plane"></i></button>
                        </form>
                    </div>
                </div>
            </div>      
        </>
    )
}

export default Footer